import * as vanilla from 'OK/utils/vanilla';
import {IAjaxResponseData} from "OK/utils/vanilla";
import logger from 'OK/logger';

let underLayerEl: HTMLElement | null = null;
let loadingPromise: Promise<IAjaxResponseData<unknown>> | null = null;
let startPreloadTimer = 0;

function preload() {
    if (!loadingPromise) {
        loadingPromise = vanilla.ajax({
            url: window.OK.getCurrentStateLink(),
            data: {
                cmd: 'MiddleColumn'
            },
            headers: {
                'STRD': 'reset'
            }
        });
    }
    return loadingPromise;
}

function loadContent() {
    underLayerEl?.classList.add('__loading');
    preload()
        .then(vanilla.updateBlockModelCallback)
        .catch((e: Error) => logger.error('', `UnderLayerManager - error while preload content: ${e?.message}`));
}

function onLayerChanged(layerId: string, isVisible: boolean, result?: any) {
    if (!isVisible) {
        loadContent();
    }
}

export function activate(el: HTMLElement) {
    underLayerEl = el;
    if (!window.OK.Layers.isAnyLayerOpened(true)) {
        loadContent();
        return;
    }
    window.OK.Layers.subscribeGlobal(onLayerChanged);
    startPreloadTimer = setTimeout(preload, +el.getAttribute('data-preload-timeout')!);
}

export function deactivate() {
    window.OK.Layers.unsubscribeGlobal(onLayerChanged);
    underLayerEl = null;
    loadingPromise = null;
    clearTimeout(startPreloadTimer);
    startPreloadTimer = 0;
}
